import { Subscription } from 'rxjs';
import { ContentManagementService } from './../../shared/services/content-management.service';
import { AppStateService } from './../../shared/services/app-state.service';
import { Component, OnInit, OnDestroy, Directive  } from '@angular/core';
import { NavigationEnum } from '../navbar/navigation.enum';
import { environment } from '../../../environments/environment';
import { NavigationLink, getFooterLinks } from '../../shared/common/navigation-links';
import { Router, NavigationEnd, NavigationCancel, RouterLink } from '@angular/router';
import { Location, NgIf, NgFor } from '@angular/common';
import { Site } from '../../shared/models';
import { DomainTypeEnum } from '../../policy/models/domain-type.enum';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { tick } from '@angular/core/testing';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [NgIf, NgFor, RouterLink]
})
export class FooterComponent implements OnInit, OnDestroy {
  partnerName: string;
  footerContent: SafeHtml;
  partnerNameSub: Subscription;
  globalContentSub: Subscription;
  agencyInfoSub: Subscription;
  agaLogoUrl: string;
  appVersion: string;
  navbarColor: string;
  path: string;
  clp: boolean;
  private _partnerConfig: Site;

  private _links: Array<NavigationLink> = getFooterLinks();

  get links() { return this._links; }

  getActiveLinks() { return this.links.filter(l => l.active === true); }

  constructor(
    private appStateService: AppStateService, private router: Router, private location: Location, private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.router.events.subscribe(event => {
      // we used to hide pre-footer on custom landing pages

      //if (event instanceof NavigationEnd) {
      // this.clp = this.location.path().includes('clp');
      //}
    });

    this.partnerNameSub = this.appStateService.partnerNameObservable$.subscribe(value => {
      this.partnerName = value;
    });

    this.globalContentSub = this.appStateService.globalContentObservable$.subscribe(gc => {
      this.footerContent = this.sanitizer.bypassSecurityTrustHtml(gc.footer);
      this.agaLogoUrl = gc.agaLogo;
      setTimeout(() => {
        this.checkDomain();
      });
    });

    this.agencyInfoSub = this.appStateService.agencyInfoObservable$.subscribe(config => {
      this.links.find(l => l.type === NavigationEnum.CoverageOptions).active = config.displayProductPage;
    });

    this.agencyInfoSub = this.appStateService.agencyInfoObservable$.subscribe(config => {
      this.navbarColor = config.colors.primaryBarColor;
    });

    this.appVersion = environment.version;

    const currentYear = new Date().getFullYear();
    document.getElementById('current-year').textContent = currentYear.toString();
  }

  ngOnDestroy() {
    this.partnerNameSub.unsubscribe();
    this.globalContentSub.unsubscribe();
    this.agencyInfoSub.unsubscribe();
    this.agencyInfoSub.unsubscribe();
  }

  checkDomain() {
    this._partnerConfig = this.appStateService.getPartnerConfig();
    if (this._partnerConfig.domain) {
      switch (this._partnerConfig.domain) {
        case(DomainTypeEnum.Travel):
          this.showTravelFooter();
          break;
        case(DomainTypeEnum.EventTicketProtection):
          this.showTicketFooter();
          break;
        case(DomainTypeEnum.EventRegistration):
          this.showTicketFooter();
          break;
        case(DomainTypeEnum.Session):
          this.showTicketFooter();
          break;
        case(DomainTypeEnum.Season):
          this.showTravelFooter();
          break;
      }
    }
  }

  showTravelFooter() {
    const ticketFooterElement = document.getElementById('ticket-footer');
    const travelFooterElement = document.getElementById('travel-footer');
    if (ticketFooterElement) {
      ticketFooterElement.style.display = 'none';
    }
    if (travelFooterElement) {
      travelFooterElement.style.display = 'block';
    }
  }

  showTicketFooter() {
    const travelFooterElement = document.getElementById('travel-footer');
    const ticketFooterElement = document.getElementById('ticket-footer');
    if (travelFooterElement) {
      travelFooterElement.style.display = 'none';
    }
    if (ticketFooterElement) {
      ticketFooterElement.style.display = 'block';
    }
  }
 
}
